module.exports = __webpack_public_path__ + "img/4_75.3edd4346.png";